import { firebaseDb, uid } from './index'
import { NEW_PARCEL_ID } from '../config/variables'
import { checkCount } from '../config/account'
import { onIncreaseCount } from '../reducers/account'
import DSI from '../config/tableLayoutIndexes'
import { actionTagsReceive } from '../reducers/tagList'

export const getParcelList = (id, dispatch, onSuccess) => {
  let promises = []
  promises.push(firebaseDb().ref(`parcels/${id}`).once('value'))
  promises.push(firebaseDb().ref(`owners/${id}`).once('value'))
  promises.push(firebaseDb().ref(`tags/${id}`).once('value'))
  Promise.all(promises)
    .then(snapshots => {
        dispatch(onSuccess(id, snapshots[0].val(), snapshots[1].val()))
        const tags = snapshots[2].val()
        if (tags) {
          dispatch(actionTagsReceive(tags, id))
        }
    })
    .catch(error => {
      console.log(error)
    })
}

export const saveParcel = (dispatch, onParcelSaved, projectId, parcelId, parcelData,
    ownersDataArr, count, increaseCount ) => {
  if (parcelId === NEW_PARCEL_ID) {
    const parcelsRef = firebaseDb().ref(`parcels/${projectId}`)
    let newParcelRef = parcelsRef.push()
    parcelId = newParcelRef.key
    newParcelRef.set(parcelData)
      .then(() => {
        saveParcel(dispatch, onParcelSaved, projectId, parcelId, parcelData,
          ownersDataArr, count, true)
      })
    return
  }
  let updates = {}
  let accountInfo = null
  if (increaseCount) {
    updates[`users/${uid()}/account/c`] = count
    accountInfo = checkCount(count)
    updates[`users/${uid()}/account/as`] = accountInfo.as
    updates[`users/${uid()}/account/o`] = accountInfo.o
  }
  let updatedOwners = null
  let addedOwners = []
  if (ownersDataArr) {
    updatedOwners = {}
    let ownersId = ownersDataArr[0]
    let ownersData = ownersDataArr[1]
    let edited = ownersDataArr[2]
    let added = ownersDataArr[3]
    for (let i = 0; i < edited.length; i++) {
      const curId = edited[i]
      let curO = ownersData[ownersId.indexOf(curId)]
      delete curO.id
      updates[`owners/${projectId}/${curId}`] = curO
      updatedOwners[curId] = curO
    }
    for (var i = 0; i < added.length; i++) {
      const curId = added[i]
      let curO = ownersData[ownersId.indexOf(curId)]
      delete curO.id
      const oRef = firebaseDb().ref(`owners/${projectId}`).push()
      const newId = oRef.key
      parcelData[DSI.OWNER_NAME] =
        parcelData[DSI.OWNER_NAME].replace(curId, newId)
      updates[`owners/${projectId}/${newId}`] = curO
      updatedOwners[newId] = curO
      addedOwners.push(newId)
    }
  }
  updates[`parcels/${projectId}/${parcelId}`] = parcelData
  firebaseDb().ref().update(updates)
    .then(() => {
      dispatch(onParcelSaved(projectId, parcelId, parcelData, updatedOwners, addedOwners))
      if (increaseCount) {
        dispatch(onIncreaseCount(accountInfo, count))
      }
    })
    .catch((error) => {
      console.log(error)
    })
}

export const deleteParcels = (projectId, deletedPids, dispatch, onSuccess) => {
  let updates = {}
  for (let pid in deletedPids) {
    updates[`parcels/${projectId}/${deletedPids[pid]}`] = null
  }
  firebaseDb().ref().update(updates)
    .then(() => {
      dispatch(onSuccess(projectId, deletedPids))
    })
    .catch((error) => {
      console.log(error)
    })
}

export const massEditing = (dispatch, onSuccess, projectId, sortKey, dataIndex, upadatedData) => {
  let updates = {}
  for (let p in upadatedData) {
    updates[`${sortKey}/${projectId}/${p}/${dataIndex}`] = upadatedData[p]
  }
  firebaseDb().ref().update(updates)
    .then(() => {
      dispatch(onSuccess(projectId, sortKey, dataIndex, upadatedData))
    })
    .catch((error) => {
      console.log(error)
    })
}

export const joinOwners = (projectId, changes, orphans, first, newNote, parcels,
    dispatch, onSuccess) => {
  let updates = {}
  for (let p in changes) {
    updates[`parcels/${projectId}/${p}/${DSI.OWNER_NAME}`] = changes[p]
  }
  for (let i = 0; i < orphans.length; i++) {
    updates[`owners/${projectId}/${orphans[i]}`] = null
  }
  if (newNote !== null) {
    updates[`owners/${projectId}/${first}/no`] = newNote
  }
  firebaseDb().ref().update(updates)
    .then(() => {
      dispatch(onSuccess(projectId, parcels, orphans))
    })
    .catch((error) => {
      console.log(error)
    })
}



// WEBPACK FOOTER //
// ./src/Firebase/apiParcels.js